import { Button } from '@starsoft/common/components';
import useTranslation from 'next-translate/useTranslation';
import styles from './styles.module.scss';
import { useLottiePlayer } from '@starsoft/common/hooks';
import { useModalNavigation } from '@/hooks/modals/useModalNavigation';
import { ModalsKey } from '@/enums/modalsKey';
import { CoinType } from '@starsoft/common/models';

export default function EmptyWalletModalContent() {
  const { t } = useTranslation('common');

  const { navigateToModal } = useModalNavigation();

  const { lottieAnimationRef } = useLottiePlayer({
    path: '/wallet-filled.json',
    loop: true,
  });

  return (
    <div className={styles.container}>
      <div className={styles.container__wrapper}>
        <div
          className={styles.container__wrapper__image}
          ref={lottieAnimationRef}
        />
        <span className={styles.container__wrapper__title}>
          {t('empty_wallet_title_label', {
            app_provider: process.env.NEXT_PUBLIC_BET_NAME,
          })}
        </span>
        <span className={styles.container__wrapper__text}>
          {t('empty_wallet_textLabel')}
        </span>
      </div>

      <div className={styles.container__box}>
        <Button
          isSecondary
          onClick={() =>
            navigateToModal(ModalsKey.Deposit, `?coin-type${CoinType.Crypto}`)
          }
        >
          {t('deposit_crypto_button')}
        </Button>
        <Button
          onClick={() =>
            navigateToModal(ModalsKey.Deposit, `?coin-type${CoinType.Fiat}`)
          }
          className={styles['container__wrapper__button']}
        >
          {t('deposit_button')}
        </Button>
      </div>
    </div>
  );
}
